const ROLE_OVERRIDE_KEY = 'pulse_role_override';

/**
 * Get the current role override from localStorage.
 */
export function getRoleOverride(): string | null {
    return localStorage.getItem(ROLE_OVERRIDE_KEY);
}

/**
 * Set the role override in localStorage.
 */
export function setRoleOverride(role: string | null): void {
    if (role) {
        localStorage.setItem(ROLE_OVERRIDE_KEY, role);
    } else {
        localStorage.removeItem(ROLE_OVERRIDE_KEY);
    }
}

/**
 * Returns headers object with the role override if set.
 * Use this in all fetch calls to pass the override to the backend.
 */
export function getRequestHeaders(contentType?: string): Record<string, string> {
    const headers: Record<string, string> = {};
    if (contentType) headers['Content-Type'] = contentType;
    const override = getRoleOverride();
    if (override) headers['x-role-override'] = override;
    return headers;
}
